import * as tslib_1 from "tslib";
import { EditorType_$type } from "./EditorType";
import { IgrColumn } from "./igr-column";
import { NumericColumn } from "./NumericColumn";
import { ensureBool, ensureEnum } from "igniteui-react-core";
/**
 * Represents a Numeric grid column, used to allow the developer to display a formatted number in a cell.
*/
var IgrNumericColumn = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(IgrNumericColumn, _super);
    function IgrNumericColumn(props) {
        return _super.call(this, props) || this;
    }
    IgrNumericColumn.prototype.createImplementation = function () {
        return new NumericColumn();
    };
    Object.defineProperty(IgrNumericColumn.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrNumericColumn.prototype, "negativePrefix", {
        /**
         * Gets or sets the string to prefix a negative value. If FormatString is specificied this value is ignored.
        */
        get: function () {
            return this.i.j6;
        },
        set: function (v) {
            this.i.j6 = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrNumericColumn.prototype, "positivePrefix", {
        /**
         * Gets or sets the string to prefix a positive value. If FormatString is specificied this value is ignored.
        */
        get: function () {
            return this.i.ka;
        },
        set: function (v) {
            this.i.ka = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrNumericColumn.prototype, "negativeSuffix", {
        /**
         * Gets or sets the string to suffix a negative value. If FormatString is specificied this value is ignored.
        */
        get: function () {
            return this.i.j8;
        },
        set: function (v) {
            this.i.j8 = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrNumericColumn.prototype, "positiveSuffix", {
        /**
         * Gets or sets the string to suffix a positive value. If FormatString is specificied this value is ignored.
        */
        get: function () {
            return this.i.kc;
        },
        set: function (v) {
            this.i.kc = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrNumericColumn.prototype, "maxFractionDigits", {
        /**
         * Gets or sets the maximum fraction digits. If FormatString is specificied this value is ignored.
        */
        get: function () {
            return this.i.jo;
        },
        set: function (v) {
            this.i.jo = +v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrNumericColumn.prototype, "minFractionDigits", {
        /**
         * Gets or sets the minimum fraction digits. If FormatString is specificied this value is ignored.
        */
        get: function () {
            return this.i.jp;
        },
        set: function (v) {
            this.i.jp = +v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrNumericColumn.prototype, "minIntegerDigits", {
        /**
         * Gets or sets the minimum integer digits. If FormatString is specificied this value is ignored.
        */
        get: function () {
            return this.i.jq;
        },
        set: function (v) {
            this.i.jq = +v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrNumericColumn.prototype, "showGroupingSeparator", {
        /**
         * Gets or sets whether to show a grouping separator. If FormatString is specificied this value is ignored.
        */
        get: function () {
            return this.i.jj;
        },
        set: function (v) {
            this.i.jj = ensureBool(v);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrNumericColumn.prototype, "formatOverride", {
        /**
         * Gets or sets the INTL NumericFormat object to use for formatting the date values.
        */
        get: function () {
            return this.i.jt;
        },
        set: function (v) {
            this.i.jt = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrNumericColumn.prototype, "editorType", {
        /**
         * Gets or sets the editor type used for editing cells in this column.
        */
        get: function () {
            return this.i.jh;
        },
        set: function (v) {
            this.i.jh = ensureEnum(EditorType_$type, v);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrNumericColumn.prototype, "editorDataSource", {
        /**
         * Gets or sets the ComboBox data source.
        */
        get: function () {
            return this.i.js;
        },
        set: function (v) {
            this.i.js = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrNumericColumn.prototype, "editorTextField", {
        /**
         * Gets or sets the ComboBox text field.
        */
        get: function () {
            return this.i.jz;
        },
        set: function (v) {
            this.i.jz = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrNumericColumn.prototype, "editorValueField", {
        /**
         * Gets or sets the ComboBox value field.
        */
        get: function () {
            return this.i.jg;
        },
        set: function (v) {
            this.i.jg = v;
        },
        enumerable: true,
        configurable: true
    });
    return IgrNumericColumn;
}(IgrColumn));
export { IgrNumericColumn };
//# sourceMappingURL=igr-numeric-column.js.map
